import "./local_time.component";
import Uploader from "./uploader.component";

customElements.define('c12-uploader', Uploader)
